module.exports = __webpack_public_path__ + "static/media/order_notification.da71ae02.mp3";